<template>
  <div class="remote row column-s">
    <div class="cards column grid-12">
      <div class="controls row column-s align-center">
        <div class="title column grid-6-g grid-12-s grid-3-m hide-s">
          <b>Suas solicitações</b>
          <span>{{ jobsFilter.length }} em aberto</span>
        </div>
        <Button
          class="hide-m hide-g"
          id="enjoy"
          layout="remote-newJob"
          onclick="Kommunicate.launchConversation()"
        >
          <i class="fa fa-comment"></i> SOLICITAR ATENDIMENTO
        </Button>
        <div
          class="row justify-end justify-center-s grid-6-g grid-12-s grid-9-m"
        >
          <div class="filters row justify-space align-center hide-s">
            <div
              id="filters"
              :class="filters.todos ? 'active' : 'op'"
              @click="changeFilter('todos')"
            >
              TODAS AS SOLICITAÇÕES
            </div>
            <div
              :class="filters.aberto ? 'active' : 'op'"
              @click="changeFilter('aberto')"
            >
              SOLICITAÇÕES EM ABERTO
            </div>
            <div
              :class="filters.fechado ? 'active' : 'op'"
              @click="changeFilter('fechado')"
            >
              SOLICITAÇÕES FECHADAS
            </div>
          </div>
          <select class="input filters hide-m hide-g" v-model="search">
            <option value="">TODAS AS SOLICITAÇÕES</option>
            <option value="aberto">SOLICITAÇÕES EM ABERTO</option>
            <option value="fechado">SOLICITAÇÕES FECHADAS</option>
          </select>
        </div>
      </div>
      <div
        v-if="loader"
        class="cards-loader column align-center justify-center"
      >
        <Loader />
      </div>
      <div
        id="card-list"
        class="content row wrap grid-12-s"
        v-if="jobsFilter.length && !loader"
        @scroll="scrolled"
      >
        <Card
          v-for="(job, index) in jobsFilter"
          :key="'card' + index"
          :job="job"
          :remote="true"
          :map="openMarker"
        />
      </div>
      <div
        v-if="jobs.length == 0 && !loader"
        class="content row wrap grid-11-s"
      >
        <div class="jobs-empty grid-12 column align-center justify-center">
          <img src="../../../assets/img/remote/noFind.svg" />

          <div class="jobs-empty-text text-center">
            <br />
            <strong>Você ainda não tem solicitações!</strong>
            <br />Seus atendimentos vão aparecer aqui.
          </div>
        </div>
      </div>
      <!-- <div class="row justify-center request" v-if="!loader">
        <Button layout="remote-newJob">
          <i class="fa fa-comment"></i> SOLICITAR ATENDIMENTO
        </Button>
      </div> -->
      <Modal :modal="modal">
        <!-- <div class="row">
          <div class="title column">
            <span class="id"
              >ID JOB - <b>{{ job.id }}</b></span
            >
            Acompanhar atendimento
          </div>
          <div v-if="job.dh_chegada" class="row">
            <div><i class="fa fa-clock"></i></div>
            <div>
              Previsão de chegada:<br />
              <strong>
                {{ date.dateTimeBr(job.dh_chegada) }}
              </strong>
            </div>
          </div>
        </div> -->

        <gmap-map :center="center" :zoom="zoom">
          <gmap-polyline
            v-if="
              google &&
              job.status == 'Em trânsito' &&
              job.ultima_coordenada_doutor != null
            "
            :path="google.maps.geometry.encoding.decodePath(job.rota)"
            :options="{
              strokeColor: job.previsao_chegada_horario ? '#28BC9A' : '#FF5252',
              strokeOpacity: 1.0,
              strokeWeight: 6,
            }"
          ></gmap-polyline>
          <gmap-marker
            v-if="job.status == 'Em trânsito' && job.ultima_coordenada_doutor"
            :position="{
              lat: Number(job.ultima_coordenada_doutor.split(',')[0]),
              lng: Number(job.ultima_coordenada_doutor.split(',')[1]),
            }"
            :icon="iconMap"
            :draggable="false"
          ></gmap-marker>
          <gmap-marker
            :position="{ lat: job.latitude, lng: job.longitude }"
            :draggable="false"
          ></gmap-marker>
        </gmap-map>
      </Modal>
      <Modal :modal="firstModal" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import Loader from "@/components/Loader";
import Button from "@/components/Button";
import Card from "@/components/CardRemote.vue";
import Modal from "@/components/Modal.vue";
import date from "@/utils/date";

import * as VueGoogleMaps from "vue2-google-maps";
import { gmapApi } from "vue2-google-maps";
import IconMap from "@/statics/iconMap";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBb14nrVdCZh_uBI-wGkjjmB0ypHS4YInY",
    libraries: "geometry",
  },
});

var timeoutAttendance;

export default {
  name: "Remote",
  props: { theme: Object },
  components: {
    Card,
    Loader,
    Button,
    Modal,
  },
  data() {
    return {
      pager: 18,
      filters: {
        todos: true,
        aberto: false,
        fechado: false,
      },
      loader: true,
      search: "",
      card: { job: {}, x: "0px", y: "0px", show: false },
      center: { lat: -15.0575488, lng: -54.247716 },
      zoom: 14,
      modal: {
        show: false,
        title: "Acompanhar atendimento",
      },
      job: {},
      iconMap: IconMap,
      chatView: false,
      chat: {
        title: "Canais de atendimento",
        show: false,
      },
      firstModal: {
        show: false,
        layout: "FirstTime",
        hideClose: true,
        theme: this.theme,
      },
    };
  },
  methods: {
    ...mapActions("jobs", ["LOAD_JOBS_DIFF"]),
    ...mapActions("job", ["LOAD_ATTENDANCE_ID"]),
    openChat() {
      this.chatView = true;
    },
    closeChat() {
      this.chatView = false;
    },
    loadJobs(loader) {
      if (loader == undefined) this.loader = true;
      this.LOAD_JOBS_DIFF()
        .then(() => (this.loader = false))
        .catch(() => (this.loader = false));
    },
    loadAttendace(job) {
      this.LOAD_ATTENDANCE_ID(job.id).then((r) => {
        this.job = r;
        this.center = {
          lat: Number(r.ultima_coordenada_doutor.split(",")[0]),
          lng: Number(r.ultima_coordenada_doutor.split(",")[1]),
        };
        this.modal.description =
          "<b>Previsão de chegada: " + date.dateTimeBr(r.dh_chegada) + "</b>";
        this.modal.callback = () => clearTimeout(timeoutAttendance);
        this.modal.show = true;
      });

      var self = this;

      timeoutAttendance = setTimeout(function () {
        self.loadAttendace(job);
      }, 30000);
    },
    openMarker(job) {
      if (timeoutAttendance) clearTimeout(timeoutAttendance);
      this.loadAttendace(job);
    },
    changeFilter(op) {
      if (op != "todos") this.search = op;
      else this.search = "";
      this.filters = {};
      this.filters[op] = true;
    },
    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    scrolled(event) {
      if (
        event.target.offsetHeight + event.target.scrollTop ==
        event.target.scrollHeight
      ) {
        this.pager += 9;
      }
    },
  },
  beforeMount() {
    this.loadJobs();
  },
  mounted() {
    this.$parent.$children[0].changeMenu("remote");

    if (this.user.primeiro_acesso) this.firstModal.show = true;
    var self = this;
    setInterval(function () {
      self.loadJobs(false);
    }, 120000);
  },
  computed: {
    ...mapGetters("jobs", ["jobs"]),
    ...mapGetters("user", ["user"]),
    google: gmapApi,
    jobsFilter() {
      if (this.search) {
        return this.jobs.filter((job) => {
          if (job.status_solicitacao == this.search) return job;
        });
      } else {
        let pager = [];
        this.jobs.map((j, i) => {
          if (i < this.pager) pager.push(j);
        });
        return pager;
      }
    },
  },
};
</script>

<style lang="scss">
.remote {
  .modal-box-container {
    border-radius: 20px;
  }
}
</style>
<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.remote {
  /* height: auto; */
  padding: 0px 35px;

  @media (max-width: $small) {
    padding: 0px 10px;
  }
  background: #fff;
  .cards {
    overflow: auto;
    /* height: 600px;
    @media (min-width: $small) {
      min-height: 2275px;
    } */

    .controls {
      margin-top: 24px;
      .title {
        letter-spacing: -0.26px;
        color: #373946;
        font-size: 32px;

        span {
          color: rgba(55, 57, 70, 0.5);
          font-size: 14px;
        }
      }

      .filters {
        background: rgba(0, 0, 0, 0.05);
        color: rgba(0, 0, 0, 0.3);
        border-radius: 48px;
        height: 45px;
        font-size: 14px;

        padding: 0px 4px;
        @media (max-width: $small) {
          margin: 1.5rem 0;
          font-size: 10px;
        }
        @media (max-width: $small) {
          max-width: 700px;
        }
        .op {
          border-radius: 48px;
          padding: 9px 20px;
          cursor: pointer;
          &:hover {
            color: #777;
            font-weight: bold;
          }
        }
      }
    }

    .list {
      margin-right: 50px;
      i {
        color: $gray-9;
        width: 35px;
        height: 35px;
        border-radius: 4px;
        text-align: center;
        line-height: 38px;
        font-size: 25px;
        margin-right: 7px;
        &:hover {
          cursor: pointer;
          background: $green-2;
          color: $white;
          opacity: 0.7;
        }
      }
      .active {
        background: $white-1;
        color: $white;
      }
    }
    .status {
      margin-top: 50px;
      font-size: 15px;
      color: $gray-10;
      padding-right: 65px;
      border-bottom: 1px solid $white-1;
      padding-left: 70px;
      min-width: 800px;

      @media (max-width: $small) {
        padding-left: 25px;
        margin-top: 25px;
      }
      &-mask {
        overflow: auto;
        height: 200px;
      }
      &-container {
        overflow: hidden;
        height: 150px;
      }

      li {
        padding-bottom: 10px;
        cursor: pointer;
        &:hover {
          color: $green-1;
          border-bottom: 3px solid $green-1;
        }
      }
      .active {
        color: $green-10;
        border-bottom: 3px solid $green-10;
      }
    }

    &-loader {
      margin-top: 15%;
    }

    .content {
      padding-left: 10px;
      padding-bottom: 70px;

      overflow: auto;
      margin-right: 10px;
      margin-top: 25px;
      @media (max-width: $small) {
        height: 100vh;
        padding-left: 0px;
        margin-top: 10px;
        padding-top: 0px;
      }

      .jobs-empty {
        padding-top: 5%;
      }
    }
    .request {
      margin-top: 55px;
      button {
        font-size: 16px;
        line-height: 19px;
      }
    }
  }
  .vue-map-container {
    width: 100%;
    height: 100%;
    min-height: 500px;
    @media (min-width: $medium) {
      min-width: 800px;
    }
  }
  .id {
    padding: 6px;
    font-size: 11px;
    border-radius: 50px;
    width: normal;
  }
  #enjoy {
    width: 90%;
    margin-top: -10px;
  }
}
</style>
